import type { EntityType } from './types';

/**
 * URL-hash keys for the global scanner's deep-linkable overlay, bound via
 * `useHashDialog` (see `@/hooks/use-hash-dialog`). App-shell overlays use a
 * simple global key since they are route-agnostic.
 */
export const GLOBAL_SCANNER_HASH = {
  /** `#scanner` — GlobalScannerModal (QR scan / manual entry). */
  scan: 'scanner'
} as const;

export type GlobalScannerHashKey =
  (typeof GLOBAL_SCANNER_HASH)[keyof typeof GLOBAL_SCANNER_HASH];

/**
 * Where a resolved code leads, per entity type.
 *
 * Shared by the modal and the hardware-scanner button so the two cannot answer
 * differently — they each held a copy, and only one of them learned to check
 * that the account may open the destination.
 */
export const SCANNER_ENTITY_ROUTES: Record<
  EntityType,
  (id: number, label: string) => string
> = {
  box: (id, _label) => `/dashboard/packing/${id}`,
  shipment: (id, _label) => `/dashboard/shipping/${id}`,
  shelf: (_id, label) =>
    `/dashboard/shelves?search=${encodeURIComponent(label)}`,
  container: (id, _label) => `/dashboard/containers/${id}`
};
